const useLocalSidechain = false;

export const sideChain = !useLocalSidechain ? "https://codiaxnode.weavechain.com:443/1a2bac41a628fb7b54ca84bd3e1a2bac" : "http://localhost:40443/1a2bac41a628fb7b54ca84bd3e1a2bac";

export const authChain = "gnosis";

export const organization = "weavedemo";
export const data_collection = "codiax";
export const data_table = "directory";

export const HASHES_ADDRESS = "0xfA5F1533FBB528F37eAE0d2E55A7A717225be34c";
export const BRIDGE_ADDRESS = "0x7950C311C48B7Fb48696d421b0604Fedb9A8dF6d";
export const TOKEN_ADDRESS = "0xE097d6B3100777DC31B34dC2c58fB524C2e76921";

export const GNOSIS_POAP_ADDRESS = "https://gnosisscan.io/address/0x22c1f6050e56d2876009903609a2cc3fef83b415"

const EXPLORER_URL = "https://mumbai.polygonscan.com/address/";

export const HASHES_CONTRACT = EXPLORER_URL + HASHES_ADDRESS;
export const BRIDGE_CONTRACT = EXPLORER_URL + BRIDGE_ADDRESS;
export const TOKEN_CONTRACT = EXPLORER_URL + TOKEN_ADDRESS;

export const MARKETPLACE_URL = "https://market.weavechain.com/";

export const NOTEBOOK_URL = "http://codiaxnode.weavechain.com:18888/notebooks/demo-compute-to-data.ipynb?token=210c6ae485a710859eddc4362a55961671109a60571ebd55";

export const COMPUTE_TO_DATA_SCRIPT = `import joblib
import base64
import pandas as pd

from xgboost import XGBClassifier
from sklearn.model_selection import train_test_split
from sklearn.metrics import accuracy_score

from weaveapi.records import *
from weaveapi.options import *
from weaveh import *

scope = "Oncology Resources"
table = "Patient_Data"
TRAIN_WITH_ALL = True

nodeApi, session = connect_weave_api(None)

reply = nodeApi.read(session, scope, table, None, READ_DEFAULT).get() #use READ_DEFAULT_NO_CHAIN to skip checking hashes against the blockchain
df = pd.DataFrame(reply["data"])

X = df.loc[:, df.columns.difference(['id', 'name', 'level'])]
Y = df["level"] - 1

model = XGBClassifier()
if TRAIN_WITH_ALL:
    model.fit(X, Y) #train on all available data
else:
    seed = 123
    test_size = 0.2
    X_train, X_test, y_train, y_test = train_test_split(X, Y, test_size=test_size, random_state=seed)

    model.fit(X_train, y_train)
    y_pred = model.predict(X_test)
    predictions = [round(value) for value in y_pred]
    accuracy = accuracy_score(y_test, predictions)
    print(accuracy)

#print(model)

model.get_booster().save_model('model.serialization')
f = open("model.serialization", "rb")
data = f.read()
f.close()

result = { "model": base64.b64encode(data).decode('ascii'), "features": model.get_booster().feature_names }
weave_task_output(nodeApi, session, json.dumps(result))

nodeApi.close()
print("Done.")`;
